import { trainer } from "../../../model/trainer";

export interface IState {
    trainers: Array<trainer>;
    selectedTrainer?: trainer;
    isLoadingTrainers: boolean;
    isLoadingTrainer: boolean;
}


export const DefaultState = (): IState => ({
    trainers: [],
    isLoadingTrainers: false,
    isLoadingTrainer: false,
})
